import http from '@/utils/http';
import i18n from '@/main';

export default {
    consultarHistoricoNeoway({ size, page, ordenacao, lockScreen = true }) {
        return http.post({
            url: `/neoway/consultar-historico-neoway?page=${page}&size=${size}&sort=${ordenacao}`,
            lockScreen,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoConsultaDeHistoricoDeBuscas'
            )
        });
    },
    visualizarHistoricoNeoway({ idConsultaNeoway, lockScreen = true }) {
        return http.get({
            url: `/neoway/visualizar-historico-neoway/${idConsultaNeoway}`,
            lockScreen,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoPesquisaDoHistoricoDaConsulta'
            )
        });
    },
    visualizarTotalizadorConsultasNeoway(tipo = 'CPF', data) {
        let url = `/neoway/totalizador-consultas/?tipo=${tipo}`;

        if (data !== null && data !== undefined) {
            url += `&data=${data}`;
        }

        return http.get({
            url,
            lockScreen: false
        });
    },
    visualizarHistoricoNeowayProcessos({
        idConsultaNeoway,
        size,
        page,
        filtro,
        lockScreen = true
    }) {
        return http.get({
            url: `/neoway/consultar-historico-neoway-processo/${idConsultaNeoway}`,
            data: {
                size,
                page,
                filtro
            },
            lockScreen,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoHistoricoDeProcessosDaConsulta'
            )
        });
    },
    pesquisaNeowayPF({ cpf, lockScreen = true }) {
        return http.get({
            url: `/neoway/pessoa/${cpf}`,
            lockScreen,
            lockMessage: i18n.t('mensagens.sistema.realizandoBuscaPorCpf')
        });
    },
    pesquisaNeowayPJ({ cnpj, lockScreen = true }) {
        return http.get({
            url: `/neoway/empresa/${cnpj}`,
            lockScreen,
            lockMessage: i18n.t('mensagens.sistema.realizandoBuscaPorCnpj')
        });
    },
    pesquisaNeowayProcessos({ idConsulta, size, lockScreen = false }) {
        return http.get({
            url: `/neoway/processo-judicial/processos-documento/${idConsulta}/${size}`,
            lockScreen
        });
    },
    exportarPdfNeoway: async function (opcoesExportacao_, cpfCnpj, idConsulta) {
        const fileLink = document.createElement('a');
        const CPF_CARACTER = 11;
        let urlExport = 'exportar-analise-cnpj';
        let list = [];

        for (let op of opcoesExportacao_) {
            let opcao = {};
            opcao.nome = op;
            list.push(opcao);
        }

        if (cpfCnpj.length === CPF_CARACTER) {
            urlExport = 'exportar-analise-cpf';
        }

        try {
            let opcoesExportacao = {};
            opcoesExportacao.opcoes = list;

            return http
                .post({
                    url: `/neoway/${urlExport}/${idConsulta}`,
                    data: { opcoesExportacao },
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t(
                        'mensagens.sistema.exportandoPreAnaliseDeCredito'
                    )
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    }
};
